import Select from 'components/atoms/Select';
import { InputDescription } from 'components/atoms/styleds';
import Input from 'components/atoms/Input';
import { getErrorByKey } from 'utils';

const RoomChangeItem = ({ item, onChange, rooms, errors }) => {
  return (
    <>
      <Select
        items={rooms}
        defaultLabel='Seleziona la sala'
        label='Seleziona la sala'
        onChange={(e) => onChange('room_id', e.target.value, item)}
        // selectedKey={item.room ? item.room.id : item.room_id}
        selectedKey={!!item.room_id ? item.room_id : (item.room?.id || '')}
        // error={getErrorByKey(errors, 'slot_seats')}
      />
      <InputDescription>
        Indica il numero di coperti per questa sala se diverso dal numero
        salvato nelle impostazioni (variabile numero salvato).
      </InputDescription>
      <Input
        type='number'
        name={`total_seats_${item.id}`}
        value={ !!item.total_seats ? item.total_seats : (item.room?.total_seats || '')}
        label='Totale coperti'
        onChange={(e) => onChange('total_seats', e.target.value, item)}
        placeholder='Es: 30'
        // error={getErrorByKey(errors, 'slot_seats')}
      />
    </>
  );
};

export default RoomChangeItem;
